import {
  BoundingBox,
  HorizontalGuideline,
  VerticalGuideline,
} from "@/lib/stores/element-motion-store/element-motion-state";
import { useCurrentScale } from "remotion";

type Props = {
  guideline: HorizontalGuideline | VerticalGuideline;
  selectionBoundingBox: BoundingBox | null;
};

export default function Guideline({ guideline, selectionBoundingBox }: Props) {
  const scale = useCurrentScale();

  if (!selectionBoundingBox) {
    return null;
  }

  let left: number;
  let top: number;
  let right: number;
  let bottom: number;

  if (guideline.type === "VERTICAL") {
    left = guideline.x;
    right = guideline.x + 1 / scale;
    top = Math.min(selectionBoundingBox.top, guideline.top);
    bottom = Math.max(selectionBoundingBox.bottom, guideline.bottom);
  } else {
    top = guideline.y;
    bottom = guideline.y + 1 / scale;
    left = Math.min(selectionBoundingBox.left, guideline.left);
    right = Math.max(selectionBoundingBox.right, guideline.right);
  }

  const width = right - left;
  const height = bottom - top;

  return (
    <div
      style={{
        pointerEvents: "none",
        position: "absolute",
        left,
        top,
        width,
        height,
        backgroundColor: "red",
      }}
    ></div>
  );
}
